import { useLayoutEffect, useRef, useState } from "react"
import Tooltip from "@mui/material/Tooltip"
import ClickAwayListener from "@mui/material/ClickAwayListener"

const clampStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 4,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
}

// Table-cell text clamped to 4 lines so long content doesn't stretch the row;
// when it's actually cut off, the full text shows in a bubble — on click
// (default) or on hover (`hover`).
export default function NoteCell({ text, hover = false, minWidth, maxWidth = 220 }) {
  const ref = useRef(null)
  const [truncated, setTruncated] = useState(false)
  const [open, setOpen] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    setTruncated(!!el && el.scrollHeight > el.clientHeight + 1)
  }, [text])

  if (!text) return "—"

  if (hover) {
    return (
      <Tooltip title={truncated ? text : ""} arrow placement="top">
        <div ref={ref} style={{ ...clampStyle, minWidth, maxWidth }}>
          {text}
        </div>
      </Tooltip>
    )
  }

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <span>
        <Tooltip
          open={open && truncated}
          title={<span style={{ whiteSpace: "pre-wrap" }}>{text}</span>}
          arrow
          placement="top"
          disableHoverListener
          disableFocusListener
          disableTouchListener
        >
          <div
            ref={ref}
            style={{ ...clampStyle, maxWidth, cursor: truncated ? "pointer" : undefined }}
            onClick={() => truncated && setOpen((o) => !o)}
          >
            {text}
          </div>
        </Tooltip>
      </span>
    </ClickAwayListener>
  )
}
